import Service from "../../AuthService";
const checkedBag = {
    getCheckBag(page) {
        return Service.get("/checked_bag?page="+page);
    },
    showCheckBag(id) {
        return Service.get("/checked_bag/"+id);
    },
    createCheckBag(data){
        return Service.post("/checked_bag",data);
    },
    updateCheckBag(id,data) {
        return Service.put("/checked_bag/"+id ,data);
    },
    deleteCheckBag(id){
        return Service.delete("/checked_bag/"+id);
    },
    getBagData() {
        return Service.get("/bag_data_all");
    },
    getCheckBagByType(page,type_id){
        return Service.post("/checked_bag_type?page="+page+
            "&bag_type_id="+type_id);
    },
    getVendorFromBag(data){
        return Service.post("/vendor_bag",data);
    }
};
export default checkedBag;
